import { EFORM_DOWNLOAD_ERROR, EFORM_DOWNLOAD_REQUEST, EFORM_DOWNLOAD_SUCCESS, E_FORM_GENERATION_ERROR, E_FORM_GENERATION_REQUEST, E_FORM_GENERATION_RESET, E_FORM_GENERATION_SUCCESS } from "@/actions/eform/actionTypes";

export const initialState = {

    eFormGenStatusLoading: false,
    eFormGenStatusSuccess: false,
    eFormGenStatusError: '',
    fileExists: false,
    fileName: '',
    fileType: false,
    generatedDate:'',
    eFormDwnldLoading: false,
    eFormDwnldSuccess: false,
    eFormDwnldError: '',

};

const eFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case E_FORM_GENERATION_REQUEST:
            return {
                ...state,
                eFormGenStatusLoading: true,
                eFormGenStatusSuccess: false,
                eFormGenStatusError: ''
            };
        case E_FORM_GENERATION_SUCCESS:
            return {
                ...state,
                eFormGenStatusLoading: false,
                fileName: action.data.fileNmae,
                fileType: action.data.fileType,
                generatedDate : action.data.generatedDate,
                eFormGenStatusSuccess: true
            };
        case E_FORM_GENERATION_ERROR:
            return {
                ...state,
                eFormGenStatusLoading: false,
                eFormGenStatusError: action.error.response?.data?.message,
                eFormGenStatusSuccess: false
            };
        case E_FORM_GENERATION_RESET:
            return initialState;
        case EFORM_DOWNLOAD_REQUEST:
            return {
                ...state,
                eFormDwnldLoading: true,
                eFormDwnldSuccess: false,
                eFormDwnldError: '',
            };
        case EFORM_DOWNLOAD_SUCCESS:
            return {
                ...state,
                eFormDwnldLoading: false,
                eFormDwnldSuccess: true,
                eFormDwnldError: '',
            };
        case EFORM_DOWNLOAD_ERROR:
            return {
                ...state,
                eFormDwnldLoading: false,
                eFormDwnldSuccess: false,
                eFormDwnldError: action.error.response?.data?.message
            };
        default:
            return state;
    }
}

export default eFormReducer;